import { getSiteFromHostname } from '@/composables/UseUrl'

export const location =
  document.documentElement && document.documentElement.lang
    ? document.documentElement.lang.split(/[,;]/)[0].trim().toLocaleLowerCase()
    : 'en-us'
export const language = location.split('-')[0]
export const region = location.split('-')[1]
export const overrideDomain = localStorage.getItem('override-domain') || ''
export const site = getSiteFromHostname()
export const SearchBarTypes = {
  HOTEL: 'hotel',
  ADVANCED_SEARCH: 'advancedSearch',
  AUTOCOMPLETE: 'autocomplete',
  ROOM_DISPLAY: 'roomDisplay',
  SEARCH_RESULTS: 'searchResults',
  REWARDS: 'rewards',
  CALENDAR: 'calendar',
  OFFERS: 'offers',
  MODIFY_DATES: 'modifyDates',
  DESTINATIONS: 'destinations',
  HOTEL_LIST: 'hotelList'
}
export const maxStayLength = 90
